import { FC, ReactNode, useState, createContext, useContext } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { responsiveFontSizes, Theme } from "@mui/material/styles";
import { darkTheme, lightTheme } from "../utils/theme";

export interface IThemeContext {
  toggleTheme: () => void;
  mode: "light" | "dark";
  theme: Theme;
}

const ThemeContext = createContext<IThemeContext>({
  toggleTheme: () => false,
  mode: "light",
  theme: lightTheme,
});

const MUIThemeProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [mode, setMode] = useState<"light" | "dark">("light");
  const [theme, setTheme] = useState(lightTheme);
  const THEMEObj = {
    light: lightTheme,
    dark: darkTheme,
  };
  const toggleTheme = () => {
    setMode(mode === "light" ? "dark" : "light");
    setTheme(THEMEObj[mode]);
  };

  console.log(mode);
  return (
    <ThemeContext.Provider value={{ toggleTheme, mode, theme }}>
      <ThemeProvider theme={responsiveFontSizes(theme)}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};

export default MUIThemeProvider;

export const useThemeContext = () => useContext(ThemeContext);
